import { render } from "./EmployeeCareerPathDetail.vue?vue&type=template&id=72510bb2"
import script from "./EmployeeCareerPathDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeCareerPathDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__